import { useState, useMemo } from "react";
import type { LabResult, LabReading } from "../types";

export interface UseLabResultDetailsProps {
  result: LabResult;
}

export const useLabResultDetails = ({ result }: UseLabResultDetailsProps) => {
  const latestReading = useMemo(() => {
    return result.readings.reduce((latest, r) => (new Date(r.date) > new Date(latest.date) ? r : latest));
  }, [result.readings]);

  const [selectedReading, setSelectedReading] = useState<LabReading>(latestReading);

  // Update selected when result changes
  const effectiveReading = useMemo(() => {
    return result.readings.find((r) => r.id === selectedReading.id) ?? latestReading;
  }, [result.readings, selectedReading.id, latestReading]);

  const sortedReadings = useMemo(() => {
    return [...result.readings].sort((a, b) => new Date(b.date).getTime() - new Date(a.date).getTime());
  }, [result.readings]);

  return {
    latestReading,
    selectedReading,
    setSelectedReading,
    effectiveReading,
    sortedReadings,
  };
};

export type UseLabResultDetailsReturn = ReturnType<typeof useLabResultDetails>;
